var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-analytics" }, [
    _c("div", { staticClass: "ctm-analytics__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ctm-analytics__controls" },
        [
          _c(
            "el-select",
            {
              staticClass: "ctm-analytics__form-select",
              attrs: {
                clearable: "",
                filterable: "",
                placeholder: "All Forms"
              },
              on: { change: _vm.fetchData },
              model: {
                value: _vm.selectedFormId,
                callback: function($$v) {
                  _vm.selectedFormId = $$v
                },
                expression: "selectedFormId"
              }
            },
            _vm._l(_vm.forms, function(form) {
              return _c("el-option", {
                key: form.id,
                attrs: { label: form.name, value: form.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ctm-date-presets" },
            _vm._l(_vm.presets, function(p) {
              return _c(
                "button",
                {
                  key: p.key,
                  class: [
                    "ctm-preset-btn",
                    { "ctm-preset-btn--active": _vm.activePreset === p.key }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.applyPreset(p)
                    }
                  }
                },
                [_vm._v(_vm._s(p.label))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("el-date-picker", {
            staticClass: "ctm-analytics__datepicker",
            attrs: {
              type: "daterange",
              "range-separator": "–",
              "start-placeholder": "Start date",
              "end-placeholder": "End date",
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd"
            },
            on: { change: _vm.onDateChange },
            model: {
              value: _vm.dateRange,
              callback: function($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-stats-grid" },
      _vm._l(_vm.statCards, function(stat) {
        return _c("div", { key: stat.key, staticClass: "ctm-stat-card" }, [
          _c(
            "div",
            {
              class: [
                "ctm-stat-card__icon",
                "ctm-stat-card__icon--" + stat.color
              ]
            },
            [_c("i", { class: stat.icon })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ctm-stat-card__body" }, [
            _c("div", { staticClass: "ctm-stat-card__value" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.loading ? "—" : stat.value + (stat.suffix || "")) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-stat-card__label" }, [
              _vm._v(_vm._s(stat.label))
            ])
          ])
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ctm-funnel-card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "ctm-funnel-card__body"
        },
        [
          _c("div", { staticClass: "ctm-funnel" }, [
            _c("div", { staticClass: "ctm-funnel__step" }, [
              _c("div", { staticClass: "ctm-funnel__step-meta" }, [
                _c("span", { staticClass: "ctm-funnel__step-num" }, [
                  _vm._v(_vm._s(_vm.data.total_views))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "ctm-funnel__step-label" }, [
                  _vm._v("Views")
                ])
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("span", { staticClass: "ctm-funnel__step-pct" }, [
                _vm._v("100%")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-funnel__connector" }, [
              _c("i", {
                staticClass: "el-icon-arrow-down ctm-funnel__connector-icon"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ctm-funnel__connector-rate" }, [
                _vm._v(_vm._s(_vm.engagementRate) + "% engaged")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-funnel__step" }, [
              _c("div", { staticClass: "ctm-funnel__step-meta" }, [
                _c("span", { staticClass: "ctm-funnel__step-num" }, [
                  _vm._v(_vm._s(_vm.engaged))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "ctm-funnel__step-label" }, [
                  _vm._v("Started")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctm-funnel__bar-track" }, [
                _c("div", {
                  staticClass:
                    "ctm-funnel__bar-fill ctm-funnel__bar-fill--amber",
                  style: { width: _vm.engagementRate + "%" }
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ctm-funnel__step-pct" }, [
                _vm._v(_vm._s(_vm.engagementRate) + "%")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-funnel__connector" }, [
              _c("i", {
                staticClass: "el-icon-arrow-down ctm-funnel__connector-icon"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ctm-funnel__connector-rate" }, [
                _vm._v(_vm._s(_vm.completionRate) + "% completed")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ctm-funnel__step" }, [
              _c("div", { staticClass: "ctm-funnel__step-meta" }, [
                _c("span", { staticClass: "ctm-funnel__step-num" }, [
                  _vm._v(_vm._s(_vm.data.total_submissions))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "ctm-funnel__step-label" }, [
                  _vm._v("Submitted")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctm-funnel__bar-track" }, [
                _c("div", {
                  staticClass:
                    "ctm-funnel__bar-fill ctm-funnel__bar-fill--green",
                  style: { width: _vm.overallRate + "%" }
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ctm-funnel__step-pct" }, [
                _vm._v(_vm._s(_vm.overallRate) + "%")
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ctm-chart-card" }, [
      _c("div", { staticClass: "ctm-chart-card__head" }, [
        _c("span", { staticClass: "ctm-chart-card__title" }, [
          _vm._v("Views vs Submissions")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ctm-series-toggles" },
          _vm._l(_vm.seriesOptions, function(s) {
            return _c(
              "button",
              {
                key: s.key,
                class: [
                  "ctm-series-btn",
                  { "ctm-series-btn--on": _vm.visible[s.key] }
                ],
                on: {
                  click: function($event) {
                    _vm.visible[s.key] = !_vm.visible[s.key]
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "ctm-series-dot",
                  style: {
                    background: _vm.visible[s.key] ? s.color : "#d1d5db"
                  }
                }),
                _vm._v(
                  "\n                    " +
                    _vm._s(s.label) +
                    "\n                "
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "ctm-chart-card__body"
        },
        [
          _vm.hasChartData
            ? _c("LineChart", {
                attrs: {
                  labels: _vm.data.labels,
                  submissions: _vm.data.submissions,
                  views: _vm.data.views,
                  abandonments: _vm.data.abandonments,
                  visible: _vm.visible
                }
              })
            : _c("div", { staticClass: "ctm-empty-state" }, [
                _c("i", {
                  staticClass: "el-icon-data-line ctm-empty-state__icon"
                }),
                _vm._v(" "),
                _c("p", { staticClass: "ctm-empty-state__text" }, [
                  _vm._v("No activity in the selected period")
                ])
              ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ctm-bottom-row" }, [
      _c("div", { staticClass: "ctm-chart-card ctm-chart-card--half" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "ctm-chart-card__body"
          },
          [_c("DeviceChart", { attrs: { devices: _vm.data.devices } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ctm-chart-card ctm-chart-card--half" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "ctm-chart-card__body"
          },
          [
            _vm.data.top_forms && _vm.data.top_forms.length
              ? [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.data.top_forms, size: "small" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "form_name",
                          label: "Form",
                          "min-width": "110",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "views",
                          label: "Views",
                          width: "56",
                          align: "right"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "submissions",
                          label: "Subs",
                          width: "56",
                          align: "right"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Conversion", "min-width": "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("div", { staticClass: "ctm-conv-cell" }, [
                                    _c("div", { staticClass: "ctm-conv-bar" }, [
                                      _c("div", {
                                        staticClass: "ctm-conv-bar__fill",
                                        style: {
                                          width:
                                            Math.min(row.conversion_rate, 100) +
                                            "%"
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "ctm-conv-pct" },
                                      [
                                        _vm._v(
                                          _vm._s(row.conversion_rate) + "%"
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          909018866
                        )
                      })
                    ],
                    1
                  )
                ]
              : _c(
                  "div",
                  { staticClass: "ctm-empty-state ctm-empty-state--sm" },
                  [
                    _c("i", {
                      staticClass: "el-icon-document ctm-empty-state__icon"
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "ctm-empty-state__text" }, [
                      _vm._v("No submissions yet")
                    ])
                  ]
                )
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-analytics__header-left" }, [
      _c("h1", { staticClass: "ctm-analytics__title" }, [_vm._v("Analytics")]),
      _vm._v(" "),
      _c("p", { staticClass: "ctm-analytics__subtitle" }, [
        _vm._v("Track views, submissions and conversions across your forms")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-funnel-card__head" }, [
      _c("div", [
        _c("span", { staticClass: "ctm-funnel-card__title" }, [
          _vm._v("Conversion Funnel")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ctm-funnel-card__sub" }, [
          _vm._v("How visitors move from view to submission")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-funnel__bar-track" }, [
      _c("div", {
        staticClass: "ctm-funnel__bar-fill ctm-funnel__bar-fill--blue",
        staticStyle: { width: "100%" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-chart-card__head" }, [
      _c("span", { staticClass: "ctm-chart-card__title" }, [
        _vm._v("Device Breakdown")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-chart-card__head" }, [
      _c("span", { staticClass: "ctm-chart-card__title" }, [
        _vm._v("Top Forms")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }